import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  DocumentInfo,
  EditorButtonConfiguration,
  EditorEditItem,
  IconType,
  IoniconsFilled,
  IoniconsOutline,
  PtPermissions,
} from '@pt/pt-models';
import { WidgetDialogService } from '../../services/widget-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import { getDocInfo } from '../../store/widget.selectors';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompleteStatusDialogComponent } from '../../dialogs/complete-status-dialog.component';
import { from } from 'rxjs';
import { CommonDocumentEditorDetails } from '@primatoo-ms-organization';

@Component({
  selector: 'pt-template-header',
  templateUrl: 'template-header.component.html',
  styleUrls: ['template-header.component.scss'],
})
export class TemplateHeaderComponent implements OnChanges {
  @Input() isDraft: boolean;

  @Input() docInfo: DocumentInfo;

  @Input() loading: boolean;

  @Input() documentPermission: AvailableOperations;

  @Input() descriptionButton: EditorButtonConfiguration;

  @Input() documentEditorDetails: CommonDocumentEditorDetails;

  @Input() headerEntityName: string;

  @Input() headerTitle: string;

  @Input() templateStatusLabel: string;

  @Input() headerIconKey: string;

  @Input() description: string;

  @Input() isPublishedDocument: boolean;

  @Output() updateDescription = new EventEmitter<string>();

  @Output() enabledEditTreatment = new EventEmitter<EditorEditItem>();

  @Output() clickLogo = new EventEmitter();


  PtPermissions = PtPermissions;
  IconType = IconType;
  IconWarning = IoniconsOutline.warning;
  IconReload = IoniconsOutline.reload;
  IconEdit = IoniconsOutline.edit;

  currentDescriptionValue: string;
  currentDescriptionHTML: string;
  public readonly iconSize = 16;
  public readonly IconHistory = IoniconsFilled.time;

  constructor(
    private widgetDialogService: WidgetDialogService,
    private translateService: TranslateService,
    public modalService: NgbModal
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.description) {
      this.currentDescriptionValue = changes.description.currentValue;
      this.currentDescriptionHTML = this.currentDescriptionValue
        ? this.currentDescriptionValue.split('\n').join('<br>')
        : '';
    }
  }

  completedDialog() {
    const modalRef = this.modalService.open(CompleteStatusDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    modalRef.componentInstance.commonDocumentEditorDetails = this.documentEditorDetails;
    from(modalRef.result).subscribe(() => {});
  }

  history() {
    if (this.docInfo) {
      this.widgetDialogService.runHistoryDialog(this.docInfo);
    }
  }

  editDescription() {
    this.currentDescriptionValue = this.description;
    this.currentDescriptionHTML = this.currentDescriptionValue
      ? this.currentDescriptionValue.split('\n').join('<br>')
      : '';
    this.enabledEditTreatment.emit(EditorEditItem.DESCRIPTION);
  }

  resetDescription() {
    this.currentDescriptionValue = this.description;
    this.currentDescriptionHTML = this.currentDescriptionValue
      ? this.currentDescriptionValue.split('\n').join('<br>')
      : '';
    this.enabledEditTreatment.emit(null);
  }

  saveDescription() {
    this.updateDescription.emit(this.currentDescriptionValue);
  }

  openTextArea(value: string, editable: boolean, autosave: boolean) {
    const dialog = this.widgetDialogService.runTextArea(
      this.translateService.stream('LABELS.DESCRIPTION'),
      value,
      editable
    );
    dialog.subscribe((desciption: string) => {
      this.currentDescriptionValue = desciption;
      this.currentDescriptionHTML = this.currentDescriptionValue
        ? this.currentDescriptionValue.split('\n').join('<br>')
        : '';
      if (autosave) {
        this.saveDescription();
      }
    });
  }

  activeFocus(description: HTMLTextAreaElement) {
    setTimeout(() => {
      description.focus();
    });
  }

  protected readonly getDocInfo = getDocInfo;
}
